/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage your organization's compliance settings and policies" |
*
* @param {Compliance_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_subtitle = /** @type {((inputs?: Compliance_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalte die Compliance-Einstellungen und -Richtlinien deiner Organisation")
	return /** @type {LocalizedString} */ ("Manage your organization's compliance settings and policies")
});